import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {
  ServiceAutomationDetail,
  ServiceAutomationDetailFilter,
  ServiceAutomationDetailInput
} from './service-automation-detail.model';

export const loadServiceAutomationDetails = createAction(
  '[ServiceAutomationDetail/API] Load ServiceAutomationDetails',
  props<{ serviceAutomationDetails: ServiceAutomationDetail[] }>()
);

export const addServiceAutomationDetail = createAction(
  '[ServiceAutomationDetail/API] Add ServiceAutomationDetail',
  props<{ serviceAutomationDetail: ServiceAutomationDetail }>()
);

export const upsertServiceAutomationDetail = createAction(
  '[ServiceAutomationDetail/API] Upsert ServiceAutomationDetail',
  props<{ serviceAutomationDetail: ServiceAutomationDetail }>()
);

export const addServiceAutomationDetails = createAction(
  '[ServiceAutomationDetail/API] Add ServiceAutomationDetails',
  props<{ serviceAutomationDetails: ServiceAutomationDetail[] }>()
);

export const upsertServiceAutomationDetails = createAction(
  '[ServiceAutomationDetail/API] Upsert ServiceAutomationDetails',
  props<{ serviceAutomationDetails: ServiceAutomationDetail[] }>()
);

export const updateServiceAutomationDetail = createAction(
  '[ServiceAutomationDetail/API] Update ServiceAutomationDetail',
  props<{ serviceAutomationDetail: Update<ServiceAutomationDetail> }>()
);

export const updateServiceAutomationDetails = createAction(
  '[ServiceAutomationDetail/API] Update ServiceAutomationDetails',
  props<{ serviceAutomationDetails: Update<ServiceAutomationDetail>[] }>()
);

export const deleteServiceAutomationDetail = createAction(
  '[ServiceAutomationDetail/API] Delete ServiceAutomationDetail',
  props<{ id: string }>()
);

export const deleteServiceAutomationDetails = createAction(
  '[ServiceAutomationDetail/API] Delete ServiceAutomationDetails',
  props<{ ids: string[] }>()
);

export const clearServiceAutomationDetails = createAction(
  '[ServiceAutomationDetail/API] Clear ServiceAutomationDetails'
);

// CUSTOM
export const createServiceAutomationDetails = createAction(
  '[ServiceAutomationDetail/API] create ServiceAutomationDetail',
  props<{ input: ServiceAutomationDetailInput }>()
);

export const editServiceAutomationDetails = createAction(
  '[ServiceAutomationDetail/API] edit ServiceAutomationDetail',
  props<{ input: ServiceAutomationDetailInput }>()
);

export const getServiceAutomationDetails = createAction(
  '[ServiceAutomationDetail/API] get all ServiceAutomationDetail',
  props<{ filtering: ServiceAutomationDetailFilter }>()
);

export const removeServiceAutomationDetails = createAction(
  '[ServiceAutomationDetail/API] remove ServiceAutomationDetail',
  props<{ detailsUniqueId: string; id: string }>()
);
